var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlexibleCredit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5 50C11.6929 50 0.5 38.8071 0.5 25C0.5 11.1929 11.6929 0 25.5 0C39.3071 0 50.5 11.1929 50.5 25C50.5 38.8071 39.3071 50 25.5 50Z",
    fill: "#27490F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.987 15H35.883C37.2508 15 38.37 16.1194 38.37 17.4875V32.4125C38.37 33.7806 37.2508 34.9 35.883 34.9H15.987C14.6192 34.9 13.5 33.7806 13.5 32.4125V17.4875C13.5 16.1194 14.6191 15 15.987 15Z",
    fill: "#27490F",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.37 17.485L25.935 26.1976L13.5 17.485",
    fill: "#27490F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.37 17.485L25.935 26.1976L13.5 17.485",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexibleCredit);
export default __webpack_public_path__ + "static/media/flexible-credit.5b174bf05bb469f1414cbeddda6dca53.svg";
export { ForwardRef as ReactComponent };